module.exports = __webpack_public_path__ + "img/guquan-send-icon.563181d4.png";